// === SAA:UTILS:DOORLOPENDE-REIS-PRICING:v1 ===
// Display premium for the Doorlopende reis (DFD / K781) product.
//
// Like every SAA product, the customer-facing price is shown EX-PROVISION: the agent
// provision (DR_PPRC, typically 20%) is stripped from the gross premium (DR_BTP).
//
// UNLIKE the other products, this DFD cover carries NO assurantiebelasting — the BFF
// returns DR_TASS = 0 (and DR_BTP = DR_NTP = DR_TTOT), so the usual ×1.21 tax step is ×1.0.
// There is also no package/UI discount on this product.
//
//   display = floor( DR_BTP × (1 − DR_PPRC/100) )
//
// Works off the coverage section whether the live payload calls it DR or OD.

export const computeDoorlopendeReisDisplayPremium = (pp: any): number => {
  const dr = pp?.DR || pp?.OD;
  const btp = Number(dr?.DR_BTP ?? dr?.OD_BTP);
  const pprc = Number(dr?.DR_PPRC ?? dr?.OD_PPRC ?? 20);
  if (isFinite(btp) && btp > 0) {
    return Math.floor(btp * (1 - pprc / 100) * 100) / 100;
  }
  // Fallback: PP-level total when the section/BTP isn't available yet.
  const ttot = Number(pp?.PP_TTOT);
  return isFinite(ttot) && ttot > 0 ? ttot : 0;
};
